import { Component, OnInit, OnDestroy, ComponentRef } from '@angular/core';

import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ProgressSpinnerComponent } from './common/progress-spinner/progress-spinner.component';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';

import { SpinnerService } from './services/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent {

  title = 'facility-management-sample';
  private overlayRef: OverlayRef | null = null;
  private loadingCounter = 0;
  spinner: ComponentRef<ProgressSpinnerComponent> | undefined;

  constructor(
    protected overlay: Overlay,
    private titleService: Title,
    private translate: TranslateService,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit(): void {
    this.translate.get('PAGE_TITLE').subscribe(title => {
      this.titleService.setTitle(title);
    });

    // 言語変更時に title も更新
    this.translate.onLangChange.subscribe(() => {
      this.translate.get('PAGE_TITLE').subscribe(title => {
        this.titleService.setTitle(title);
      });
    });
  }

  ngOnDestroy(): void {
  }

}
